import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Slider from 'react-slick';
import { Link, useHistory } from 'react-router-dom';
import {ImageUrl} from '../../../../../Helpers/request'
import { LazyLoadImage } from "react-lazy-load-image-component";
let ShapeData = [
  {
    img:`${ImageUrl}vector_shapes/asscher.svg`,
    img2:`${ImageUrl}diamond-shape/asscher-diamond.webp`,
    title: 'Asscher',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/cushion.svg`,
    img2:`${ImageUrl}diamond-shape/cushion-diamond.webp`,
    title: 'Cushion',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/emerald.svg`,
    img2:`${ImageUrl}diamond-shape/emerald-diamond.webp`,
    title: 'Emerald',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/heart.svg`,
    img2:`${ImageUrl}diamond-shape/heart-diamond.webp`,
    title: 'Heart',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/marquise.svg`,
    img2:`${ImageUrl}diamond-shape/marquise-diamond.webp`,
    title: 'Marquise',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/oval.svg`,
    img2:`${ImageUrl}diamond-shape/oval-diamond.webp`,
    title: 'Oval',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/pear.svg`,
    img2:`${ImageUrl}diamond-shape/pear-diamond.webp`,
    title: 'Pear',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/princess.svg`,
    img2:`${ImageUrl}diamond-shape/princess-diamond.webp`,
    title: 'Princess',
    link: '#',
  },
  {
    img:`${ImageUrl}vector_shapes/radiant.svg`,
    img2:`${ImageUrl}diamond-shape/radiant-diamond.webp`,
    title: 'Radiant',
    link: '#',
  },
];

var settings = {
  dots: true,
  infinite: true,
  arrows: true,
  speed: 500,
  accessibility: true,
  autoplay: true,
  slidesToShow: 9,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 6,
      },
    },
  ],
};

const ShapeBy = () => {
  const [img, setImg] = useState();
  var history = useHistory();
  const shopbyshape = (value) => {
    var data1 = {
      shape: value,
    };
    sessionStorage.setItem('bw_d_filter', JSON.stringify(data1));
    history.push('/diamonds');
    window.scrollTo(0, 0);
  };

  return (
    <section className="pt80 pb80 ptMob30 pbMob30">
      <Container className="">
        <div className="text-center mx-auto mb-md-5 mb-3">
          <h3 className="title_heading mb-0 pb-0  d-block text-uppercase  fontMessiri">Shop Diamonds By Shape</h3>
        </div>

        <Slider {...settings} className="overflow-hidden shapeBySl">
          {ShapeData?.map((val, index) => {
            console.log('val', ShapeData?.[0].img);
            return (
              <li key={index}>
                <button className="noBtn" onClick={() => shopbyshape(val?.title)} title={val.title}>
                  <div className="imgWrapper">
                    <LazyLoadImage src={img === index ? val.img2 : val.img} onMouseEnter={() => setImg(index)} onMouseLeave={() => setImg(null)} alt="" />
                  </div>
                  <h3 className="RingSettingTitleSPL fontMessiri mt-4">{val.title}</h3>
                </button>
              </li>
            );
          })}
        </Slider>
      </Container>
    </section>
  );
};

export default ShapeBy;
